module.exports = __webpack_public_path__ + "static/media/install3.e9374fa2.png";